import React, {Component, Fragment} from "react";
import {DurableFunctionInstance} from "../../../models/DurableFunctionInstance";
import MailroomDurableFunctionInstanceList from ".././MailroomDurableFunctionInstanceList";
import PageTitle from "../../PageTitle";
import {NewBulkComparisonCard} from "./NewBulkComparisonCard";
import {ICDBPageProps} from "../../../utils/ICDBPageProps";
import {BulkFetchDataCard} from "../BulkFetchDataCard";


export interface MailroomBulkComparisonListPageState {
    loadingInstances: boolean;
    loadingTrigger: boolean;
    
    reloadConfig: boolean;
    
    bulkInstances?: DurableFunctionInstance[];
}

export default class MailroomBulkComparisonListPage extends Component<ICDBPageProps , MailroomBulkComparisonListPageState> {
    static displayName = MailroomBulkComparisonListPage.name;
    
    constructor(props: ICDBPageProps) {
        super(props);

        this.state = {
            loadingTrigger: false,
            loadingInstances: false,
            
            reloadConfig: false,
            
            bulkInstances: undefined
        };
    }

    public async componentDidMount() {
        await this.getInstances();
    }

    
    private async getInstances() {
        
        this.setState({
            loadingInstances: true
        });

        try {

            const instances = await this.props.apiService.getMailroomBulkProcessorComparisonInstances();

            this.setState({
                bulkInstances: instances,
                loadingInstances: false
            });
            
        }
        catch (e) {
            console.log(e);
            this.props.messageBar.error(`Failed to get bulk processor comparison instances : ${e}`);
            this.setState({
                loadingInstances: false
            })
        }
    }
    


    public render() {
        return (
            <Fragment>
                <PageTitle title="Bulk Comparisons"/>
                
                <BulkFetchDataCard apiService={this.props.apiService} messageBar={this.props.messageBar}/>
                
                <NewBulkComparisonCard apiService={this.props.apiService} messageBar={this.props.messageBar} onTriggered={async () => { await this.getInstances()}}/>
                
                <MailroomDurableFunctionInstanceList 
                    title={"Bulk Comparisons"}
                    enableRowLinks={true}
                    instances={this.state.bulkInstances}
                    linkForInstance={(dfi) => `/cdb-admin/mailroom/bulk-processor-comparison/${dfi.durableFunctionInstanceId}`}
                    columns={MailroomDurableFunctionInstanceList.genericColumns}/>
            </Fragment>
        );
    };
}
